module.exports = __webpack_public_path__ + "static/img/getmore.ac0f582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/getmore.png
// module id = DB/G
// module chunks = 1